import(/* webpackMode: "eager", webpackExports: ["WikiContextProvider"] */ "/vercel/path0/src/context/wikiContext.tsx");
